// extracted by mini-css-extract-plugin
export default {"collapsible":"collapsible","entry":"entry","icon":"icon","value":"value","actions":"actions","content":"content"};